import type { BadgeVariant } from '../../components/ui/Badge';
import type { KhoaDich } from '../../i18n';
import { MAU_TOKEN } from '../nhat-ky-truy-vet/chung/components/BieuDo';
import type { MucHanMucAi } from './nghiep-vu/token-ai';
import type { ChuKyHanMucAi, HanhDongHanMucAi, PhamViHanMucAi, TheoPhanRa } from './types';

type TongPhanLoai = Extract<BadgeVariant, 'violet' | 'teal' | 'orange' | 'info'>;

/** Phạm vi và hành động là **phân loại**, không phải trạng thái: "Chặn" không có nghĩa dòng này đang hỏng. */
export const PHAM_VI: Record<PhamViHanMucAi, { nhan: KhoaDich; tong: TongPhanLoai }> = {
  DON_VI: { nhan: 'manTokenAi.phamViDonVi', tong: 'violet' },
  NGUOI_DUNG: { nhan: 'manTokenAi.phamViNguoi', tong: 'teal' },
};

export const HANH_DONG: Record<HanhDongHanMucAi, { nhan: KhoaDich; tong: TongPhanLoai }> = {
  CHAN: { nhan: 'manTokenAi.hanhDongChan', tong: 'orange' },
  CANH_BAO: { nhan: 'manTokenAi.hanhDongCanhBao', tong: 'info' },
};

export const CHU_KY: Record<ChuKyHanMucAi, KhoaDich> = {
  NGAY: 'manTokenAi.chuKyNgay',
  TUAN: 'manTokenAi.chuKyTuan',
  THANG: 'manTokenAi.chuKyThang',
};

export const CAC_CHU_KY: ChuKyHanMucAi[] = ['NGAY', 'TUAN', 'THANG'];

export const TONG_MUC_HAN_MUC: Record<MucHanMucAi, { thanh: string; chu: string }> = {
  'binh-thuong': { thanh: 'bg-primary-500', chu: 'text-content-secondary' },
  'canh-bao': { thanh: 'bg-warning-500', chu: 'text-warning-700' },
  het: { thanh: 'bg-danger-500', chu: 'text-danger-700' },
};

/** Cùng màu đầu vào, đầu ra với biểu đồ token Fox ở Nhật ký sử dụng AI: một loạt, một màu ở mọi màn. */
export const MAU_VAO = MAU_TOKEN.dau_vao;
export const MAU_RA = MAU_TOKEN.dau_ra;

/** Câu cho dòng `khoa: null` của từng cách chia. */
export const NHAN_KHONG_GAN: Record<TheoPhanRa, KhoaDich> = {
  TINH_NANG: 'manTokenAi.khongGanTinhNang',
  DON_VI: 'manTokenAi.khongGanDonVi',
  NGUOI_DUNG: 'manTokenAi.khongGanNguoi',
};
